var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoolAndFitnessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 195,
    height: 195,
    viewBox: "0 0 195 195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88.616,
    height: 84.677,
    fill: "#104864"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-684.999 -1373.998)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 97.5,
    r: 97.5,
    transform: "translate(684.999 1373.998)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(740.445 1429.159)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.957,72.547A22.792,22.792,0,0,0,72.3,40.015v.047l-.843-.281.179-.6h-.613V22.786a1.3,1.3,0,0,0-.089-.464l-.059-.119a1.428,1.428,0,0,0-.085-.179L64.35,12.377h5.36a1.326,1.326,0,0,0,.93-.385,1.3,1.3,0,0,0,.386-.93V8.469h6.5a1.307,1.307,0,0,0,.931-.386l5.862-5.862A1.316,1.316,0,0,0,82.451.369L76.982,5.838H71.026V3.245a1.3,1.3,0,0,0-.386-.929,1.324,1.324,0,0,0-.93-.386H50.17a5.224,5.224,0,0,0,0,10.447h3.2l7.2,10.8v10.49L36.2,44.92H24.128V29.964h4.547a5.224,5.224,0,0,0,0-10.447H16.312V14.97a5.223,5.223,0,1,0-10.446,0v7.816a7.178,7.178,0,0,0,7.177,7.178h.639V45.245l-.5.112a16.93,16.93,0,0,0,.706,33.165l.628.114-.618,3.41H7.18a1.315,1.315,0,0,0,0,2.631H15a1.314,1.314,0,0,0,1.295-1.08l.868-4.782H50.106a.888.888,0,0,1,.157-.027l.27-.02.2.179a22.792,22.792,0,0,0,35.222-6.4M50.17,9.746a2.593,2.593,0,0,1,0-5.186H68.4V9.746Zm6.359,2.631H61.19l6.062,9.094H62.59ZM68.4,24.1V53.075l-.767-.157a10.661,10.661,0,0,0-1.826-.182h0a8.49,8.49,0,0,0-1.825.182l-.767.157V24.1Zm-7.19,33.17a6.5,6.5,0,1,1-1.9,4.6,6.453,6.453,0,0,1,1.9-4.6m-.627-20.706v3.114l-.48.123A22.754,22.754,0,0,0,50.74,44.76l-.181.16H42.48ZM13.042,27.333A4.547,4.547,0,0,1,8.5,22.786V14.97a2.593,2.593,0,1,1,5.186,0v5.862a1.307,1.307,0,0,0,.386.931,1.325,1.325,0,0,0,.929.384H28.675a2.593,2.593,0,0,1,0,5.186ZM21.5,44.92H16.313V29.964H21.5ZM16.472,67.927l-.786-.453a6.489,6.489,0,1,1,4.263.784l-.89.142L20.2,62.1a1.314,1.314,0,0,0-1.057-1.521h-.006a1.3,1.3,0,0,0-1.522,1.048Zm1.166,8.258.944-5.2.521-.011a9.135,9.135,0,1,0-3.593-.651l.484.194-1.005,5.535-.631-.119a14.317,14.317,0,0,1,2.591-28.387h31.1l-.736,1.014a22.633,22.633,0,0,0,0,26.606l.736,1.014ZM65.8,82.048a20.18,20.18,0,0,1-6.054-39.426l.831-.262V54.422l-.256.192a9.132,9.132,0,1,0,10.958,0l-.256-.192V42.364l.831.263A20.179,20.179,0,0,1,68.211,81.9l.3.149Z",
    transform: "translate(0 0)",
    fill: "#104864"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoolAndFitnessIcon);
export default __webpack_public_path__ + "static/media/PoolAndFitnessIcon.44eecb3f39e1d943e51c6301e5f1479d.svg";
export { ForwardRef as ReactComponent };